import { motion } from 'motion/react';
import type { WorkOption } from '../types';

interface PersonaShapesProps {
  step?: 1 | 2 | 3;
  selectedWorkOption: WorkOption | null;
}

export function PersonaShapes({ step = 1, selectedWorkOption }: PersonaShapesProps): JSX.Element {
  const getContainerStyle = () => {
    if (step === 3) {
      return { transform: 'translate(-90px, 230px) scale(1)', opacity: 1 };
    }
    if (step === 2 && selectedWorkOption !== null) {
      return { transform: 'translate(-200px, -200px) scale(0.9)', opacity: 0.4 };
    }
    return undefined;
  };

  return (
    <div
      className="absolute left-[455px] top-[360px] transition-all duration-1000"
      style={getContainerStyle()}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.5 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        <svg
          width="259"
          height="259"
          viewBox="0 0 259 259"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_9861_2086)">
            <mask
              id="mask0_9861_2086"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="259"
              height="259"
            >
              <path d="M258.086 0H0V258.086H258.086V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_9861_2086)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.00312798 258.086C0.00104426 257.872 0 257.657 0 257.441C0 224.678 24.1783 197.561 55.6655 192.962C24.2215 188.646 0 161.673 0 129.043C0 93.409 28.8874 64.5216 64.5216 64.5216H65.1668C29.3915 64.5216 0.349343 35.6935 0.00312798 0H258.084C257.737 35.6935 228.696 64.5216 192.92 64.5216H193.565C229.199 64.5216 258.086 93.409 258.086 129.043C258.086 161.673 233.865 188.646 202.421 192.962C233.908 197.561 258.086 224.678 258.086 257.441C258.086 257.657 258.085 257.872 258.084 258.086H0.00312798Z"
                fill="#3893FF"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_9861_2086">
              <rect width="258.086" height="258.086" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </motion.div>
      <motion.div
        className="absolute -left-[215px] -top-[140px]"
        initial={{ opacity: 0, rotate: 90, scale: 0.5 }}
        animate={{ opacity: 1, rotate: 0, scale: 1 }}
        exit={{ opacity: 0, rotate: -180, scale: 0.5 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        <svg
          width="318"
          height="318"
          viewBox="0 0 318 318"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_9861_2093)">
            <mask
              id="mask0_9861_2093"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="318"
              height="318"
            >
              <path d="M317.235 0H0V317.235H317.235V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_9861_2093)">
              <path
                d="M158.617 317.235C148.153 317.235 138.515 314.619 129.703 309.386C121.166 304.43 114.282 297.684 109.049 289.147C104.093 280.334 101.614 270.697 101.614 260.231C101.614 247.013 104.643 235.999 110.702 227.186C116.76 218.375 126.123 208.047 138.79 196.207C148.153 187.67 152.835 179.545 152.835 171.835V164.401H145.399C136.863 164.401 125.159 172.937 110.289 190.011C95.6937 207.085 77.9318 215.62 57.0031 215.62C46.5388 215.62 36.9006 213.142 28.0885 208.185C19.5518 202.953 12.6674 196.069 7.43519 187.532C2.4784 178.721 0 169.081 0 158.617C0 148.153 2.4784 138.653 7.43519 130.116C12.6674 121.304 19.5518 114.419 28.0885 109.463C36.9006 104.23 46.5388 101.614 57.0031 101.614C77.6564 101.614 95.2805 110.013 109.876 126.811C124.471 143.609 136.312 152.008 145.399 152.008H152.835V145.399C152.835 137.689 148.153 129.565 138.79 121.028L129.29 112.354C122.405 106.02 116.072 98.4475 110.289 89.6353C104.506 80.5478 101.614 69.6705 101.614 57.0031C101.614 46.5388 104.093 37.0383 109.049 28.5016C114.282 19.6895 121.166 12.8051 129.703 7.84825C138.515 2.61608 148.153 0 158.617 0C169.081 0 178.583 2.61608 187.119 7.84825C195.931 13.0804 202.816 19.9649 207.773 28.5016C213.004 37.0383 215.62 46.5388 215.62 57.0031C215.62 77.6564 207.221 95.2805 190.423 109.876C173.626 124.471 165.227 136.312 165.227 145.399V152.008H171.835C181.198 152.008 193.039 143.609 207.359 126.811C221.403 110.013 239.027 101.614 260.233 101.614C270.697 101.614 280.196 104.23 288.733 109.463C297.546 114.419 304.43 121.166 309.386 129.703C314.619 138.24 317.235 147.878 317.235 158.617C317.235 169.081 314.619 178.721 309.386 187.532C304.43 196.069 297.546 202.953 288.733 208.185C280.196 213.142 270.697 215.62 260.233 215.62C247.289 215.62 236.137 212.454 226.774 206.12C217.687 199.787 207.497 190.561 196.207 178.445C187.67 169.081 179.545 164.401 171.835 164.401H165.227V171.835C165.227 182.025 173.626 193.865 190.423 207.359C207.221 220.853 215.62 238.477 215.62 260.231C215.62 270.697 213.004 280.334 207.773 289.147C202.816 297.684 196.069 304.43 187.532 309.386C178.995 314.619 169.357 317.235 158.617 317.235Z"
                fill="#FFA68B"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_9861_2093">
              <rect width="317.235" height="317.235" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </motion.div>
    </div>
  );
}
